import axios from "axios";

export function getEttEventList() {
  return axios({
    method: "get",
    baseURL: `${CONFIG["ETT_SERVICE"]}/?_pageNum=1&_pageSize=1000&_sortBy=startDate+asc`,
    headers: {
      "Cache-Control": "no-cache"
    }
  });
}

export function getEttEvent(id) {
  return axios({
    method: "get",
    baseURL: `${CONFIG["ETT_SERVICE"]}/${id}`,
    headers: {
      "Cache-Control": "no-cache"
    }
  });
}

export function getDrawingList() {
  return axios({
    method: "get",
    baseURL: `${CONFIG["DRAWING_SERVICE"]}/`,
    withCredentials: true
  });
}

export function getDrawing(id) {
  return axios({
    method: "get",
    baseURL: `${CONFIG["DRAWING_SERVICE"]}/${id}`,
    withCredentials: true
  });
}

export function createDrawing(config) {
  return axios({
    method: "post",
    baseURL: `${CONFIG["DRAWING_SERVICE"]}/`,
    headers: {
      "Content-Type": "application/json"
    },
    data: config,
    withCredentials: true
  });
}

export function updateDrawing(id, config) {
  return axios({
    method: "put",
    baseURL: `${CONFIG["DRAWING_SERVICE"]}/${id}`,
    headers: {
      "Content-Type": "application/json"
    },
    data: config,
    withCredentials: true
  });
}

export function archiveDrawing(id) {
  return axios({
    method: "delete",
    baseURL: `${CONFIG["DRAWING_SERVICE"]}/${id}`,
    withCredentials: true
  });
}

export function purgeDrawing(id) {
  return axios({
    method: "delete",
    baseURL: `${CONFIG["DRAWING_SERVICE"]}/${id}?purge=true`,
    withCredentials: true
  });
}

export function activateDrawing(id) {
  return axios({
    method: "post",
    baseURL: `${CONFIG["DRAWING_SERVICE"]}/${id}/activate`,
    headers: {
      "Content-Type": "application/json"
    },
    data: {},
    withCredentials: true
  });
}

export function getAttendeeList(drawingId) {
  return axios({
    method: "get",
    baseURL: `${CONFIG["DRAWING_SERVICE"]}/${drawingId}/attendees`,
    withCredentials: true
  });
}

export function getWinnerList(id) {
  return axios({
    method: "get",
    baseURL: `${CONFIG["DRAWING_SERVICE"]}/${id}/winners`,
    withCredentials: true
  });
}

export const DEFAULT_LIMIT = 2001;

export function getLimitedAttendeeListWithAllWinners({ drawingId, limit = DEFAULT_LIMIT }) {
  return new Promise((resolve, reject) => {
    axios({
      method: "get",
      baseURL: `${CONFIG["DRAWING_SERVICE"]}/${drawingId}/winners`,
      withCredentials: true
    })
      .then(({ data: winners }) => {
        axios({
          method: "get",
          baseURL: `${CONFIG["DRAWING_SERVICE"]}/${drawingId}/attendees?limit=${limit}`,
          withCredentials: true
        })
          .then(({ data: attendees }) => {
            const data = [...attendees];
            winners.forEach(winner => {
              if (!attendees.find(attendee => winner.id === attendee.id)) {
                const idx = Math.floor(Math.random() * limit);
                data.splice(idx, 0, winner);
              }
            })
            resolve({ data });
          })
          .catch(reject);
      })
      .catch(reject);
  });
}

export function createWinner(id, excludeCompanies) {
  return axios({
    method: "post",
    baseURL: `${CONFIG["DRAWING_SERVICE"]}/${id}/winners`,
    headers: {
      "Content-Type": "application/json"
    },
    data: {
      excludes_companies: excludeCompanies
    },
    withCredentials: true
  });
}

export function deleteAttendee(drawingId, attendeeId) {
  return axios({
    method: "delete",
    baseURL: `${CONFIG["DRAWING_SERVICE"]}/${drawingId}/attendees/${attendeeId}`,
    withCredentials: true
  });
}

export function deleteAllAttendees(drawingId) {
  return axios({
    method: "delete",
    baseURL: `${CONFIG["DRAWING_SERVICE"]}/${drawingId}/attendees`,
    withCredentials: true
  });
}

export function deleteWinner(drawingId, attendeeId) {
  return axios({
    method: "delete",
    baseURL: `${CONFIG["DRAWING_SERVICE"]}/${drawingId}/winners/${attendeeId}`,
    withCredentials: true
  });
}

export function generateUrl(project) {
  const { raffle_url, secret_url_path } = project;
  const isValidUrl = /^(http)/.test(raffle_url);
  const isValidPath = /^\//.test(raffle_url);

  const pathUrl = (
    isValidUrl
      ? raffle_url
      : isValidPath
        ? `https://developer.cisco.com${raffle_url}`
        : undefined
  );

  // To have an anchor part of URL, you must already have a valid path and a secret.
  const anchorUrl = pathUrl && secret_url_path && `#${secret_url_path}`;

  return anchorUrl ? `${pathUrl}${anchorUrl}` : pathUrl;
}

export function toQrUrl(url) {
  const qrUrl = `${CONFIG["QR_SERVICE"]}${url}`;
  const qrUrlEncoded = qrUrl.replace(/#/g, "%23");

  return qrUrlEncoded;
}